export const COOKIE_CONSENT_KEY = "cookie-consent";

export type CookieConsentValue = "accepted" | "declined" | null;

export const getCookieConsent = (): CookieConsentValue => {
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (consent === "accepted" || consent === "declined") {
    return consent;
  }
  return null;
};

export const setCookieConsent = (value: "accepted" | "declined"): void => {
  localStorage.setItem(COOKIE_CONSENT_KEY, value);
};
